import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { api, ApiError } from '@/lib/axios'
import { Toast } from '../components/Toast'

type ExecuteAuthResponse = {
  application_url: string
  token: string
}

async function executeAuthRequest(id: string) {
  const { data } = await api.backend.get<ExecuteAuthResponse>(
    `/application-account-users-auth/execute-auth/${id}`,
  )
  return data
}

export function useExecuteAuth() {
  const { t } = useTranslation('common')

  const { mutateAsync, isPending } = useMutation<
    ExecuteAuthResponse,
    AxiosError<ApiError>,
    { id: string }
  >({
    mutationKey: ['/application-account-users-auth/execute-auth'],
    mutationFn: ({ id }) => executeAuthRequest(id),
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: OctagonAlert,
          title: t('app_login.errors.execute_auth_error'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('app_login.errors.execute_auth_error_description'),
        },
      })
    },
  })

  const handleExecuteAuth = async (id: string) => {
    return mutateAsync({ id })
  }

  return { handleExecuteAuth, isExecutingAuth: isPending }
}
